import { Component, ChangeDetectionStrategy } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import { RouterModule } from '@angular/router';

import { RqaLayoutComponent } from '@layout/app.layout';
@Component({
  selector: 'rqa-root',
  templateUrl: './app.component.html',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [RouterModule, RqaLayoutComponent]
})
export class AppComponent {
  constructor(
    private meta: Meta,
    private titleService: Title
  ) {
    this.setLanguage();
  }

  private setLanguage() {
    this.meta.addTags([
      { name: 'description', content: 'Panel administracyjny' },
      { name: 'author', content: 'PAŻP' }
    ]);

    this.titleService.setTitle('Administration panel');
  }

}
